import { io } from "socket.io-client";
import { URL } from "../../constant/url";

export const socket = io(URL, {
  autoConnect: true,
});